import React, { Component } from 'react';
import { Column, Row, Button, Form, FormInput, cls } from '../../packages/components';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import { LocalTranslations } from '../../requests/apa/local';
import translatesJson from './ModalPoliticas.translates.json';
import AAF from './../../AAF/AAF';
import PropTypes from 'prop-types';
import {HIDE_MODAL, MODAL_POLITICA_DE_PRIVACIDAD, MODAL_TERMINOS_Y_CONDICIONES
} from '../../actions/modal';
import { apaLegals } from '../../requests/loader';
import Legals from '../../requests/apa/Legals';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import store from '../../store';
import Utils from 'src/utils/Utils';
import {GA4} from 'src/utils/trackers/GA4';
import {PRIVACY_POLICES_TERMS, PRIVACY_POLICES_POLICES, PRIVACY_POLICES_CONTINUE} from 'src/utils/trackers/GA4Constants';
import {Tooltip} from 'src/packages/components/lib/Tooltip';
import logger from 'src/utils/logger/logger';
import {
    trackAuthTermsAccepted,
    trackAuthTermsDeclined,
    trackAuthTermsShown,
} from '../../services/datadog/auth';
import './styles/ModalPoliticas.scss';

const localTranslations = new LocalTranslations(translatesJson);

const MAIN_CLASSNAME = 'aaf_app_modal-policies';
const TITLE_KEY = 'noticePrivacy_popupTitle_label'
const TITLE_DEFAULT = 'Aviso de privacidad'
const SUBTITLE_KEY = 'noticePrivacy_popupDescription_label'
const SUBTITLE_DEFAULT = 'Para continuar, acepte los nuevos términos y condiciones del servicio.'
const CHECK_KEY = 'noticePrivacy_popupValidate_label'
const CHECK_DEFAULT = 'Acepto los nuevos términos y condiciones y politicas de privacidad del servicio.'
const BUTTON_TERMS_AND_CONDITIONS_KEY = 'noticePrivacy_popupTermsConditions_option_button'
const BUTTON_TERMS_AND_CONDITIONS_DEFAULT = 'CONOCER TÉRMINOS y CONDICIONES'
const BUTTON_PRIVACY_POLICIES_KEY = 'noticePrivacy_popupPrivacyPolicy_option_button'
const BUTTON_PRIVACY_POLICIES_DEFAULT = 'CONOCER POLÍTICAS DE PRIVACIDAD'
const BUTTON_CONTINUE_KEY = 'noticePrivacy_popupContinue_option_button'
const BUTTON_CONTINUE_DEFAULT = 'CONTINUAR'
const TERMS_AND_CONDITIONS_KEY = 'tyc_full_text';
const PRIVACY_POLICIES_KEY = 'pp_full_text';
const CHECK_TERMS_LABEL_VALIDATION = 'password_tooltip_checkTermsConditions_label_validation';
const CHECK_TERMS_LABEL_VALIDATION_DEFAULT = 'Debes aceptar los Términos y Condiciones';


const Title = () => {
    return (
        <Column lg={12}>
            <p className={cls(`${MAIN_CLASSNAME}-title`)}>
                {localTranslations.get(TITLE_KEY, TITLE_DEFAULT)}
            </p>
        </Column>
    )
}

const Subtitle = () => {
    return (
        <Column lg={12}>
            <p className={cls(`${MAIN_CLASSNAME}-subtitle`)}>
                {localTranslations.get(SUBTITLE_KEY, SUBTITLE_DEFAULT)}
            </p>
        </Column>
    )
}

const CheckAccept = (props) => {
    const {checked, handleChangeCheck = ()=>{}} = props;
    return (
        <Column lg={12} className={cls(`${MAIN_CLASSNAME}-check`)}>
            <Row>
                <FormInput
                    name="acceptPolices"
                    type="checkbox"
                    label={localTranslations.get(CHECK_KEY, CHECK_DEFAULT)}
                    checked={checked}
                    onChange={handleChangeCheck}
                />
            </Row>
        </Column>
    )
}

const getLegals = async () => {
    await  apaLegals().then((result) => {
        Legals.setData(result);
    })
    .catch(err => {
        logger.error(err);
    });
}

const hasLegals = (key) => {
    const region = DeviceStorage.getItem('region');
    const key_text = Legals.get(key, region);
    return key_text !== key;
}

const showModalTermAndCond = async (props) => {

    if (!hasLegals(TERMS_AND_CONDITIONS_KEY)) await getLegals();

    const {showModal = ()=>{}, checked, handleBack = ()=>{logger.debug('handleBack Not implemented!')}} = props || {};
    const modal = {
        modalType : MODAL_TERMINOS_Y_CONDICIONES,
        modalProps: {
            onkeyUp : (e)=>{
                document.getElementsByClassName('terms-and-conditions')[0].scrollTop -=25;
            },
            onkeyDown : (e)=>{
                document.getElementsByClassName('terms-and-conditions')[0].scrollTop +=25;
            },
            callbackWhenBack : () => {
                handleBack(checked);
            },
            handleBackKey: () => {
                handleBack(checked);
            },
            yellowAction:() => {
                handleBack(checked);
            }
        }
    };
    showModal(modal);
}

const sendGA4Metric = (event) => {
    const gA4 = new GA4();
    gA4.sendPrivacyPolices(event);
}

const hideModal = () => {
    store.dispatch({
      type: HIDE_MODAL,
      modalProps: {}
  });
}

const showPrivacyPolices = async (props) => {
    try {
        if (!hasLegals(PRIVACY_POLICIES_KEY)) await getLegals();

        const {showModal = ()=>{}, checked , handleBack = ()=>{}} = props || {};
        const modal = {
            modalType : MODAL_POLITICA_DE_PRIVACIDAD,
            modalProps: {
                onkeyUp : (e)=>{
                    document.getElementsByClassName('privacy-policies')[0].scrollTop -=25;
                },
                onkeyDown : (e)=>{
                    document.getElementsByClassName('privacy-policies')[0].scrollTop +=25;
                },
                callbackWhenBack : () => {
                    handleBack(checked);
                },
                handleBackKey: () => {
                    handleBack(checked);
                },
                yellowAction:() => {
                    handleBack(checked);
                }
            }
        };
        hideModal();
        showModal(modal);
    }
    catch (ex) {
        logger.error('ex ::: ', ex)
    }
}

const Buttons = (props) => {
    const {checked, handleChangeTooltip} = props;
    const ID_BUTTON_CONTINUE = checked ? 'btn-Continue' : 'btn-Continue-disabled';

    const handleClickContinue = (checked) => {
      if (checked) {
        sendGA4Metric(PRIVACY_POLICES_CONTINUE);
        acceptPrivacyPolices(props)
      }else {
        trackAuthTermsDeclined({
            source: 'policy_modal',
            reason: 'continue_without_acceptance',
        });
        handleChangeTooltip(true)
      }
    }

    return (
        <Column lg={12} className={cls(`${MAIN_CLASSNAME}-bottons`)}>
            <Row className={cls('row-button')}>
                <Button
                    id='btn-TermAndCond'
                    activate
                    type="button"
                    className={cls('focusable', `${MAIN_CLASSNAME}-button`)}
                    onClick={async (e) => {
                        sendGA4Metric(PRIVACY_POLICES_TERMS);
                        showModalTermAndCond(props);
                    }}
                >
                    {localTranslations.get(BUTTON_TERMS_AND_CONDITIONS_KEY, BUTTON_TERMS_AND_CONDITIONS_DEFAULT)}
                </Button>
            </Row>
            <Row className={cls('row-button')}>
                <Button
                    id='btn-PrivacyPolices'
                    activate
                    type="button"
                    className={cls('focusable', `${MAIN_CLASSNAME}-button`)}
                    onClick={(e) => {
                        sendGA4Metric(PRIVACY_POLICES_POLICES);
                        showPrivacyPolices(props);
                    }}
                >
                    {localTranslations.get(BUTTON_PRIVACY_POLICIES_KEY, BUTTON_PRIVACY_POLICIES_DEFAULT)}
                </Button>
            </Row>
            <Row className={cls('row-button')}>
                <Button
                    id={ID_BUTTON_CONTINUE}
                    type="button"
                    variant="primary"
                    className={cls('focusable', `${MAIN_CLASSNAME}-button`)}
                    onClick={() => handleClickContinue(checked)}
                >{localTranslations.get(BUTTON_CONTINUE_KEY, BUTTON_CONTINUE_DEFAULT)}
                </Button>
            </Row>
        </Column>
    )
}

const acceptPrivacyPolices = (props) => {
    const {handleModal = ()=>{}, showModal = ()=>{}} = props || {};
    const {user: {user_id = '', session_userhash: user_hash = '' } = {}} = store.getState();
    /**
     * Enviar como query param user_hash y user_id al servicio /user/settermsandconditions para que pueda ser invocado con un usuario con sesión iniciada.
     */
    const params = { ...{ terminos: 1 }, ...{ user_id, user_hash} };

    hideModal();

    AAF.Auth.login
        .acceptTermAndCond(params)
        .then((response) => {
            if (response.success) {
                trackAuthTermsAccepted({
                    source: 'policy_modal',
                });
                handleModal(true)
            } else {
                handleModal(false)
                logger.error('[ModalPoliticas]', err);
            }
        })
        .catch((err) => {
            handleModal(false)
            logger.error('[ModalPoliticas]', err);
        });
    ;
}


const BodyContent = ({ props }) => {

    const {checked, handleChangeCheck, showTooltip} = props;

    const CLASS_NAME_TOOLTIP = !showTooltip ? 'row-check-accept-tooltip-none' : 'row-check-accept-tooltip';
    const CLASS_NAME_CHECK = !showTooltip ? 'row-check-accept' : 'row-not-check-accept';
    const TITLE_TOOLTIP = localTranslations.get(CHECK_TERMS_LABEL_VALIDATION, CHECK_TERMS_LABEL_VALIDATION_DEFAULT);

    return (
        <div className={cls(`${MAIN_CLASSNAME}`)}>
            <Form id="formPoliticas">
                <Row className={cls('row-title')}>
                    <Title />
                </Row>
                <Row className={cls('row-subtitle')}>
                    <Subtitle />
                </Row>
                <Row className={cls(CLASS_NAME_CHECK)}>
                    <CheckAccept checked={checked} handleChangeCheck={handleChangeCheck} />
                </Row>
                <Row className={cls(CLASS_NAME_TOOLTIP)}>
                  <Tooltip title={TITLE_TOOLTIP} />
                </Row>
                <Row className={cls('row-buttons')}>
                    <Buttons {...props}/>
                </Row>
            </Form>
        </div>
    );
};

class ModalPoliticas extends Component {
    constructor(props) {
      super(props);
     const {checked} = props;
      this.state = {
          checked,
          showTooltip: false,
      };
      this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    addEventListener = () => {
        document.addEventListener('keydown', this.handleKeyDown, true);
    };
    removeEventListener = () => {
        document.removeEventListener('keydown', this.handleKeyDown, true);
    };

    handleKeyDown(e) {
        const currentFocused = this.getCurrentFocusedElementId();
        const focusableElements = this.getAllFocusableElements() || [];
        if (currentFocused === null || currentFocused ===''){
            this.setFocus();
        }
        else {
            if (Array.isArray(focusableElements) && !focusableElements.includes(currentFocused))
            this.setFocus();
        }
    }

    hasModalFocus() {
        return currentFocused === null || currentFocused === '';
    }

    componentDidMount(){
        this.setFocus();
        trackAuthTermsShown({
            source: 'policy_modal',
        });
        this.addEventListener();
    }

    componentWillUnmount() {
        this.removeEventListener();
    }

    getCurrentFocusedElementId() {
        const activeElement = document.activeElement;
        if (activeElement && activeElement !== document.body) {
            return activeElement.id;
        }
        return null;
    }
    getAllFocusableElements(){
        const elements = document.querySelectorAll(".aaf_app_modal-policies a.focusable");
        const result = [];
        Array.prototype.forEach.call(elements, function(element) {
            result.push(element.id)
        });

        return result
    }

    setFocus() {
        Utils.setInitialFocusChangeTime('#btn-Continue-disabled', 900);
    }

    render() {
        const p = {
            alwaysEnabled: true,
            buttonsAlign: 'vertical',
            aafNewStyle: true,
            className: 'aaf-modal',
            showLogo: true,
            classNameComponent: 'modal-policies',
            callbackWhenBack: ()=> {},
            onkeyDown:()=>{
                window.SpatialNavigation.makeFocusable();
            },
            onkeyUp:()=>{
                window.SpatialNavigation.makeFocusable();
            },
        };
        const { checked, showTooltip } = this.state || {};

        const handleChangeCheck = (checked) => {
            this.setState({checked, showTooltip: false});
        }
        const handleChangeTooltip = (showTooltip) => {
            this.setState({showTooltip});
        }

        return (
            <ModalWrapper {...p}>
                <BodyContent props={{...this.props, checked, handleChangeCheck, showTooltip, handleChangeTooltip}} />
            </ModalWrapper>
        );
    }

}


ModalPoliticas.propTypes = {
    content: PropTypes.string,
    className: PropTypes.string,
};

export default withOnClose(ModalPoliticas);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalPoliticas.jsx